import { Layout, Menu } from 'antd';
import { BarChartOutlined } from '@ant-design/icons'
import styles from "./styles.css";


const { Header } = Layout;


function currentDate(){
  var today = new Date();
  var formatDate = today.toDateString().substring(4);
  return formatDate
}

function CustomHeader() {
  return (
    <div>
      <Header className="header">
            <div style={{float: "left",color: "whitesmoke"}}>
                <a href="/" style={{cursor:"pointer"}}>
                  <span style={{fontWeight: "500",fontSize: "135%"}}>Screens <BarChartOutlined /></span>
                </a>
                <span id="headerDate">
                    {currentDate()}
                </span>
            </div>
            <Menu theme="dark" mode="horizontal" defaultSelectedKeys={[]} style={{float:"right"}}>
              <Menu.Item key="1"><a href="/about">About</a></Menu.Item>
            </Menu>
      </Header>
    </div>
  );
}

export default CustomHeader;
